import React from 'react';

export type OrchestratorHealthStatus = {
  healthy: boolean | null;
  checking: boolean;
  error: string | null;
};

export function OrchestratorStatus({ healthStatus }: { healthStatus: OrchestratorHealthStatus }) {
  if (healthStatus.checking) {
    return (
      <div className="mt-2 flex items-center gap-2 text-amber-700 text-sm">
        <span className="animate-pulse">●</span>
        <span>System starting…</span>
      </div>
    );
  }

  if (healthStatus.healthy === false) {
    return (
      <div className="mt-2 flex items-center gap-2 text-red-700 text-sm">
        <span>●</span>
        <span>System unavailable{healthStatus.error ? `: ${healthStatus.error}` : ''}</span>
      </div>
    );
  }

  return null;
}

